import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { DivisionLookup } from './division-lookup.type';
import { GuidNameCode } from './guid-name-code.type';

const BusinessAreaLookup = t.intersection(
  [
    GuidNameCode,
    t.type({
      divisions: nullable(t.array(DivisionLookup)),
    }),
  ],
  'BusinessAreaLookup',
);

type BusinessAreaLookup = t.TypeOf<typeof BusinessAreaLookup>;
export { BusinessAreaLookup };
